export default __webpack_public_path__ + "static/media/axenomic3.e75bf774.png";